/**
 * FNV-1a 32-bit hash — fast, deterministic, and works in both Node and browser.
 * Used to key pre-baked translation entries on the quote document.
 */
export function contentHash(str: string): string {
  let hash = 2_166_136_261 // FNV offset basis (32-bit)
  for (let i = 0; i < str.length; i++) {
    hash ^= str.charCodeAt(i)
    hash = Math.imul(hash, 16_777_619) >>> 0 // FNV prime, keep as uint32
  }
  return hash.toString(36)
}

/**
 * Stable key for any session/runtime translation cache.
 *
 * Persisted translation maps use contentHash(source) directly beneath their language map.
 * Runtime caches additionally need the language in the key, but must never retain the raw
 * source text as the key: using this helper keeps every translation cache content-hash based.
 */
export function contentTranslationKey(lang: string, source: string): string {
  return `${lang}:${contentHash(source)}`
}
